import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { formatDate, formatDayOfWeek } from "@/utils/dateFormatters";
import { useScheduleClubSelection } from "./useScheduleClubSelection";
import { useSlotProcessing } from "./useSlotProcessing";
import { useTrainerList } from "./useTrainerList";
import type { RootState } from "@/redux/types";

export const useSignUp = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Accordion state
  const [openAccordion, setOpenAccordion] = useState("");
  const { closeAccordionState } = useSelector((state: RootState) => state.interfaceApp);

  useEffect(() => {
    setOpenAccordion("");
  }, [closeAccordionState]);

  // Trainer filter
  const [selectedTrainer, setSelectedTrainer] = useState("all");

  // Composed hooks
  const { idClub, selectedClubValue, clubsArr, handleClubChange, userName } =
    useScheduleClubSelection();

  const { slots, slotDays, slotsLoading, hasBookingOnDay, getBookingClubOnDay, appointmentsData } =
    useSlotProcessing(idClub);

  const { listOfTrainers } = useTrainerList(idClub);

  // Wrap handleClubChange to also close accordion
  const handleClubChangeWithAccordion = useCallback(
    (clubId: string) => {
      handleClubChange(clubId);
      setOpenAccordion("");
    },
    [handleClubChange]
  );

  return {
    selectedClubValue,
    openAccordion,
    setOpenAccordion,
    formatDate,
    formatDayOfWeek,
    handleClubChange: handleClubChangeWithAccordion,
    slots,
    slotDays,
    listOfTrainers,
    clubsArr,
    selectedTrainer,
    setSelectedTrainer,
    slotsLoading,
    appointmentsData,
    userName,
    hasBookingOnDay,
    getBookingClubOnDay,
  };
};
